query DiscountCodes($code: String) {
    DiscountCodes(where: { code: { equals: $code } }, limit: 1) {
        docs {
            id
            code
            percentage
            title
            description
        }
    }
}
